// This file is the entry point for browser bundles
import { DataObject } from "../DataObject.js";
import { Procedure, ProcedureAPI } from "../Procedure.js";

export * from "./browser.esm.js";

globalThis.af = globalThis.af ?? {};
globalThis.af = globalThis.af ?? {};
globalThis.af.DataObject = DataObject;
globalThis.af.Procedure = Procedure;
globalThis.af.ProcedureAPI = ProcedureAPI;
